// extracted by mini-css-extract-plugin
export var Countdown = "Countdown-module--Countdown--b0fd0";
export var CountdownLabel = "Countdown-module--CountdownLabel--a076f";
export var CountdownLabelNumber = "Countdown-module--CountdownLabelNumber--1bbf0";
export var CountdownProgress = "Countdown-module--CountdownProgress--9a828";
export var CountdownTime = "Countdown-module--CountdownTime--c6d0d";
export var CountdownTimer = "Countdown-module--CountdownTimer--df669";
export var CountdownTimerSponsored = "Countdown-module--CountdownTimer--sponsored--556b9";
export var CountdownTotal = "Countdown-module--CountdownTotal--14444";
export var CountdownTotalSponsored = "Countdown-module--CountdownTotal--sponsored--60fe2";